export var ORIENTATION_LEFT = 'left';
export var ORIENTATION_RIGHT = 'right';